module.exports = __webpack_public_path__ + "static/media/logo-gea.dacf65c7.png";